(function () {
  const sections = document.querySelectorAll('[data-followup-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    function normalizeGerman(value) {
      return String(value || '')
        .replace(/Ae/g, 'Ä')
        .replace(/Oe/g, 'Ö')
        .replace(/Ue/g, 'Ü')
        .replace(/ae/g, 'ä')
        .replace(/oe/g, 'ö')
        .replace(/ue/g, 'ü');
    }

    function normalizeSectionText(node) {
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((textNode) => {
        if (!textNode.nodeValue || !textNode.nodeValue.trim()) return;
        textNode.nodeValue = normalizeGerman(textNode.nodeValue);
      });

      node.querySelectorAll('[placeholder]').forEach((el) => {
        el.setAttribute('placeholder', normalizeGerman(el.getAttribute('placeholder')));
      });
    }

    normalizeSectionText(root);

    const items = root.querySelectorAll('.ffu-reveal, .ffu-reveal-left, .ffu-reveal-right');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => {
            entry.target.classList.add('ffu-is-visible');
          }, index * 90);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -50px 0px' }
    );

    items.forEach((item) => observer.observe(item));
  });
})();
